import React from "react";
import { styled } from "@glitz/react";
import {
  black,
  darkGrey,
  fontSize,
  fontWeight,
  spacing,
} from "../../theme";

type Level = 1 | 2 | 3 | 4;

type Props = {
  children: React.ReactNode;
  level?: Level;
  /** Liten valfri etikett (kicker) ovanför rubriken för extra kontext. */
  kicker?: React.ReactNode;
  /** Valfri underrubrik/ingress. */
  subtitle?: React.ReactNode;
  id?: string;
};

const SectionHeading: React.FC<Props> = ({
  children,
  level = 2,
  kicker,
  subtitle,
  id,
}) => {
  return (
    <Wrap>
      {kicker ? <Kicker>{kicker}</Kicker> : null}
      {level === 1 ? (
        <H1 id={id}>{children}</H1>
      ) : level === 2 ? (
        <H2 id={id}>{children}</H2>
      ) : level === 3 ? (
        <H3 id={id}>{children}</H3>
      ) : (
        <H4 id={id}>{children}</H4>
      )}
      {subtitle ? <Subtitle>{subtitle}</Subtitle> : null}
    </Wrap>
  );
};

export default SectionHeading;

const Wrap = styled.div({
  display: "flex",
  flexDirection: "column",
  gap: spacing.xxs,
  marginBottom: spacing.m,
});

const Kicker = styled.span({
  fontSize: fontSize.xxs,
  fontWeight: fontWeight.heavy,
  color: darkGrey,
  textTransform: "uppercase",
  letterSpacing: "0.12em",
});

const H1 = styled.h1({
  color: black,
  margin: { xy: 0 },
  lineHeight: "1.2",
  fontSize: fontSize.xxl,
  fontWeight: fontWeight.heavy,
});

const H2 = styled.h2({
  color: black,
  margin: { xy: 0 },
  lineHeight: "1.2",
  fontSize: fontSize.xl,
  fontWeight: fontWeight.heavy,
});

const H3 = styled.h3({
  color: black,
  margin: { xy: 0 },
  lineHeight: "1.2",
  fontSize: fontSize.l,
  fontWeight: fontWeight.bold,
});

const H4 = styled.h4({
  color: black,
  margin: { xy: 0 },
  lineHeight: "1.2",
  fontSize: fontSize.m,
  fontWeight: fontWeight.bold,
});

const Subtitle = styled.p({
  fontSize: fontSize.s,
  color: darkGrey,
  lineHeight: "1.55",
  margin: { xy: 0 },
  marginTop: spacing.xxs,
});
